export default {
  ALLOW_MIRROR: {
    query: 'almirr',
    header: 'ALLOW-MIRROR',
    storage: localStorage,
  },
  authBySession: false,
  CDA_REDIRECT_KEY: 'redirect2cda',
  CDA_KEY: 'cda-key',
}
